import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-668fdddd"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "menu_content middle" };
const _hoisted_2 = {
    target: "_blank",
    href: "https://mypage.bigboss-financial.com/admin/cryptos_deposit/lists"
};
const _hoisted_3 = { class: "menu_content middle" };
const _hoisted_4 = {
    target: "_blank",
    href: "https://mypage.bigboss-financial.com/admin/account/cryptos_withdraw"
};
const _hoisted_5 = {
    key: 0,
    class: "menu_content middle"
};
const _hoisted_6 = { class: "language_title" };
const _hoisted_7 = {
    key: 1,
    style: { "padding": "35px 0 0 18px" }
};
const _hoisted_8 = { class: "menu_content middle" };
import { useMessage } from '@/const/messages';
import ThemeSwitch from '@/materials/molecules/ThemeSwitch.vue';
import HelpList from './HelpList.vue';
import LanguageList from '@/materials/molecules/LanguageList.vue';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isShowFullMenu: { type: Boolean },
        isAuth: { type: Boolean, default: false }
    },
    emits: ["languageClick"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const { format, MENUS_MESSAGES, USER_SETTINGS_MESSAGES } = useMessage();
        const languageClick = () => emit('languageClick');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("a", _hoisted_2, _toDisplayString(_unref(format)(_unref(MENUS_MESSAGES).DEPOSIT)), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("a", _hoisted_4, _toDisplayString(_unref(format)(_unref(MENUS_MESSAGES).WITHDRAW)), 1)
                ]),
                (_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(format)(_unref(USER_SETTINGS_MESSAGES).LANGUAGE)), 1),
                        _createVNode(LanguageList, {
                            "is-auth": props.isAuth,
                            onClick: languageClick
                        }, null, 8, ["is-auth"])
                    ]))
                    : _createCommentVNode("", true),
                (_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(ThemeSwitch)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                    (_unref(store).state.isSmartPhone)
                        ? (_openBlock(), _createBlock(HelpList, {
                            key: 0,
                            "is-show-menu": true
                        }))
                        : _createCommentVNode("", true)
                ])
            ], 64));
        };
    }
});
